import React from 'react';
import { getCapability } from '../../../services/gph/gphCapabilityRegistry';
import { getContextualHelp } from '../../../services/gph/gphContextualHelpEngine';
import { FLOW_STATES } from '../../../services/gph/gphFlowStateMachine';

// Moldura padrão dos blocos de skill: título externo amigável + ajuda contextual.
// Os nomes internos (Sensi-IA, Mi Análise, Calculadora X) nunca são o título.
export default function SkillBlockRenderer({ capabilityId, children }) {
  const capability = getCapability(capabilityId);
  const help = getContextualHelp(FLOW_STATES.COLLECTING_SKILL_INPUTS, capabilityId);

  return (
    <div className="gph-skill-block">
      {capability?.friendlyName && (
        <div className="gph-skill-block__titlebar">
          <h3 className="gph-skill-block__title">{capability.friendlyName}</h3>
        </div>
      )}
      <div className="gph-skill-block__content">{children}</div>
      {help && <p className="gph-skill-block__help">{help}</p>}
    </div>
  );
}
